import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

import Transition from '@ember/routing/-private/transition';
import SettingsSecuritySsoController from 'cio/pods/settings/security/sso/controller';
import SsoService from 'cio/services/sso';
import DS from 'ember-data';

export default class SettingsSecuritySso extends Route {
  @service sso!: SsoService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Single Sign-On (SSO)',
      path: this.routeName,
    };
  }

  async model() {
    let users = await this.store.query('user', {});

    return { users };
  }

  setupController(controller: SettingsSecuritySsoController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaults();
  }

  resetController(controller: SettingsSecuritySsoController, isExiting: boolean, transition: Transition) {
    controller.newSSOConfiguration = null;

    if (controller.ssoConfiguration != null) {
      controller.ssoConfiguration.rollbackAttributes();
    }

    return super.resetController(controller, isExiting, transition);
  }
}
